var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasDistances)?_c('svg',{staticClass:"distance-line",attrs:{"width":"100%","height":"100%"}},_vm._l((_vm.box.distances),function(ref,index){
var start_point = ref.start_point;
var end_point = ref.end_point;
var text_point = ref.text_point;
var distance = ref.distance;
return _c('g',{key:'id-' + index},[_c('line',{attrs:{"x1":start_point.x,"y1":start_point.y,"x2":end_point.x,"y2":end_point.y,"stroke":_vm.lineColor,"stroke-width":"1"}}),_c('text',{attrs:{"stroke":"black","stroke-width":".3","x":text_point.x,"y":text_point.y,"font-family":"Verdana","font-size":"16","fill":"white"}},[_vm._v(" "+_vm._s(distance)+" ")])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }